import { render, staticRenderFns } from "./ConfirmPopupWindow.vue?vue&type=template&id=072d3131&scoped=true&"
import script from "./ConfirmPopupWindow.vue?vue&type=script&lang=js&"
export * from "./ConfirmPopupWindow.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPopupWindow.vue?vue&type=style&index=0&id=072d3131&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072d3131",
  null
  
)

export default component.exports